/* Henley Spirit: "Choose chain" picker on pendant product cards.
   The tag over the card photo (.hs-card-add__chain, from snippets/hs-card-add-chain.liquid) opens a
   bottom sheet listing the product's chains. Picking one updates the card in place: price, length
   chips (50cm selected as standard), the Add to cart variant, the photos (the pendant's own chain
   photos from data-hs-card-photos, or the Cuban / Rope listing for older -market listings, like the
   product page) and the card link, so the product page opens on the same chain. Styles live in
   assets/hs-card-align.css. */
(function () {
  if (window.hsCardChainPicker) return;
  window.hsCardChainPicker = true;

  var cache = {};
  var sheet;

  function getJSON(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/<[^>]*>/g, '');
  }

  function handleOf(card) {
    var m = (card.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function chainIndex(product) {
    var names = (product.options || []).map(function (o) {
      return String(o.name || o).toLowerCase().trim();
    });
    return names.indexOf('chain');
  }

  function chainsOf(product, ci, rec) {
    var list = [];
    product.variants.forEach(function (v) {
      var value = v.options[ci];
      var row = list.filter(function (c) { return c.value === value; })[0];
      if (!row) {
        row = { value: value, price: v.price, available: false };
        list.push(row);
      }
      row.price = Math.min(row.price, v.price);
      if (v.available) row.available = true;
    });
    // The recommended chain (the one cards start on; Cuban if none is set) leads the list
    var lead = function (c) { return rec ? c.value === rec : /cuban/i.test(c.value); };
    list.sort(function (a, b) { return lead(b) - lead(a); });
    return list;
  }

  // "★ Recommended" on the recommended chain in the sheet, like the product page chain cards.
  // On every pendant since 2026-10-22 (hayden), after the gold White Clover trial.

  function recOf(card, list) {
    var rec = card.getAttribute('data-hs-card-rec');
    if (rec && list.some(function (c) { return c.value === rec; })) return rec;
    var cuban = list.filter(function (c) { return /cuban/i.test(c.value); })[0];
    return cuban ? cuban.value : null;
  }

  function isNoChain(value) {
    return /pendant only|no chain/i.test(value);
  }

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'hs-chain-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="hs-chain-sheet__overlay" data-hs-sheet-close></div>' +
      '<div class="hs-chain-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="hs-chain-sheet-title">' +
      '<div class="hs-chain-sheet__head">' +
      '<div><p class="hs-chain-sheet__title" id="hs-chain-sheet-title">Choose your chain</p>' +
      '<p class="hs-chain-sheet__product"></p></div>' +
      '<button type="button" class="hs-chain-sheet__x" data-hs-sheet-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="hs-chain-sheet__list" role="radiogroup"></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-hs-sheet-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });
  }

  function close() {
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('hs-chain-sheet-lock');
    setTimeout(function () { sheet.hidden = true; }, 250);
  }

  function open(card, product, ci) {
    if (!sheet) buildSheet();
    var current = card.getAttribute('data-hs-chain') || currentChain(card, product, ci);
    sheet.querySelector('.hs-chain-sheet__product').textContent = product.title;
    var list = sheet.querySelector('.hs-chain-sheet__list');
    list.innerHTML = '';
    var chains = chainsOf(product, ci, card.getAttribute('data-hs-card-rec'));
    var rec = recOf(card, chains);
    chains.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hs-chain-sheet__opt' + (c.value === current ? ' is-selected' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', c.value === current ? 'true' : 'false');
      b.disabled = !c.available;
      b.innerHTML =
        '<span class="hs-chain-sheet__radio"></span>' +
        '<span class="hs-chain-sheet__name"></span>' +
        '<span class="hs-chain-sheet__price"></span>';
      var name = b.querySelector('.hs-chain-sheet__name');
      name.textContent = isNoChain(c.value) ? 'Pendant only (no chain)' : c.value + ' chain';
      if (c.value === rec) {
        var star = document.createElement('span');
        star.className = 'hs-chain-sheet__rec';
        star.textContent = '★ Recommended';
        name.appendChild(star);
      }
      b.querySelector('.hs-chain-sheet__price').textContent = c.available ? money(c.price) : 'Sold out';
      b.addEventListener('click', function () {
        apply(card, product, ci, c.value);
        close();
      });
      list.appendChild(b);
    });
    sheet.hidden = false;
    document.documentElement.classList.add('hs-chain-sheet-lock');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    var focus = list.querySelector('.is-selected') || list.querySelector('button:not([disabled])');
    if (focus) focus.focus({ preventScroll: true });
  }

  function currentChain(card, product, ci) {
    var btn = card.querySelector('[data-hs-card-add]');
    var id = btn && parseInt(btn.getAttribute('data-hs-card-add'), 10);
    var v = product.variants.filter(function (x) { return x.id === id; })[0];
    return v ? v.options[ci] : null;
  }

  function apply(card, product, ci, value) {
    var variants = product.variants.filter(function (v) { return v.options[ci] === value; });
    // 50cm is the standard length; otherwise the first one in stock
    var first = variants.filter(function (v) {
      return v.available && v.options.some(function (o, i) { return i !== ci && o === '50cm'; });
    })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (!first) return;
    card.setAttribute('data-hs-chain', value);

    var label = card.querySelector('.hs-card-add__chain');
    if (label) {
      label.classList.toggle('is-no-chain', isNoChain(value));
      label.setAttribute('aria-label', 'Choose chain, currently ' + (isNoChain(value) ? 'pendant only' : value + ' chain') + '.');
    }

    var price = card.querySelector('.henley-price');
    if (price) price.textContent = money(first.price);
    var was = card.querySelector('.henley-price-was');
    if (was) was.hidden = !(first.compare_at_price > first.price);

    var chips = card.querySelector('.hs-card-add__chips');
    if (chips) {
      chips.innerHTML = '';
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hs-card-add__chip' + (v.id === first.id ? ' is-selected' : '');
        b.setAttribute('data-hs-card-variant', v.id);
        b.setAttribute('aria-pressed', v.id === first.id ? 'true' : 'false');
        b.disabled = !v.available;
        b.textContent = v.options.filter(function (_, i) { return i !== ci; }).join(' ') || value;
        chips.appendChild(b);
      });
    }
    var add = card.querySelector('[data-hs-card-add]');
    if (add) add.setAttribute('data-hs-card-add', first.id);

    card.setAttribute('href', '/products/' + product.handle + '?variant=' + first.id);
    swapPhotos(card, product.handle, value);
  }

  function showPhotos(card, srcs) {
    var imgs = card.querySelectorAll('.hs-card-media__slide img');
    imgs.forEach(function (img, i) {
      var src = srcs[i];
      if (!src) return;
      img.removeAttribute('srcset');
      img.src = src;
    });
    var track = card.querySelector('[data-hs-card-track]');
    if (track) track.scrollTo({ left: 0 });
  }

  // Same photo rule as the product page (hs-chain-photos): Rope shows the "-rope" listing,
  // everything else shows the Cuban listing (the handle without "-market").
  function swapPhotos(card, handle, value) {
    var own = card.getAttribute('data-hs-card-photos');
    if (own) {
      // Chains with no photos of their own (Curb, Figaro, Pendant Only) show the recommended chain's
      var map = {};
      try { map = JSON.parse(own) || {}; } catch (e) { map = {}; }
      var first = Object.keys(map)[0];
      var srcs = map[value] || map[card.getAttribute('data-hs-card-rec')] || (first ? map[first] : null);
      if (srcs && srcs.length) showPhotos(card, srcs);
      return;
    }
    if (!/-market$/.test(handle)) return;
    var base = handle.replace(/-market$/, '');
    var sibling = /rope/i.test(value) ? base + '-rope' : base;
    var imgs = card.querySelectorAll('.hs-card-media__slide img');
    if (!imgs.length) return;
    getJSON(sibling).then(function (p) {
      if (!p || !p.images || !p.images.length) return;
      imgs.forEach(function (img, i) {
        var src = p.images[i];
        if (!src) return;
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      });
      var track = card.querySelector('[data-hs-card-track]');
      if (track) track.scrollTo({ left: 0 });
    });
  }

  document.addEventListener('click', function (e) {
    var label = e.target.closest('.hs-card-add__chain');
    if (!label) return;
    var card = label.closest('a.henley-product-card, .henley-style-card');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = handleOf(card.matches('a') ? card : card.querySelector('a[href*="/products/"]') || card);
    if (!handle) return;
    label.classList.add('is-loading');
    getJSON(handle).then(function (product) {
      label.classList.remove('is-loading');
      if (!product) { window.location.href = '/products/' + handle; return; }
      var ci = chainIndex(product);
      if (ci < 0) { window.location.href = '/products/' + handle; return; }
      open(card, product, ci);
    });
  }, true);

  // Length chips + Add to cart on cards. Same handler as snippets/hs-card-add.liquid, whose bundled
  // {% javascript %} doesn't reach every page; the shared guard means it only binds once.
  if (!window.hsCardAddBound) {
    window.hsCardAddBound = true;
    document.addEventListener('click', function (event) {
      var go = event.target.closest('[data-hs-card-go]');
      if (go) {
        event.preventDefault();
        window.location.href = go.getAttribute('data-hs-card-go');
        return;
      }
      var chip = event.target.closest('[data-hs-card-variant]');
      if (chip) {
        event.preventDefault();
        if (chip.disabled) return;
        var box = chip.closest('[data-hs-card-add-box]');
        box.querySelectorAll('[data-hs-card-variant]').forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-selected');
        chip.setAttribute('aria-pressed', 'true');
        var addBtn = box.querySelector('[data-hs-card-add]');
        if (addBtn) addBtn.setAttribute('data-hs-card-add', chip.getAttribute('data-hs-card-variant'));
        return;
      }
      var btn = event.target.closest('[data-hs-card-add]');
      if (!btn) return;
      event.preventDefault();
      if (btn.disabled) return;
      var id = parseInt(btn.getAttribute('data-hs-card-add'), 10);
      if (!id) return;
      var text = btn.querySelector('span');
      var original = text ? text.textContent : '';
      var reset = function (delay) {
        setTimeout(function () {
          btn.disabled = false;
          if (text) text.textContent = original;
        }, delay || 0);
      };
      btn.disabled = true;
      if (text) text.textContent = 'Adding';
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          var drawer = document.querySelector('cart-drawer');
          if (state && state.sections && drawer) {
            drawer.renderContents(state);
            reset(400);
          } else if (state && state.status) {
            if (text) text.textContent = 'Unavailable';
            reset(2000);
          } else {
            window.location.href = window.routes.cart_url;
          }
        })
        .catch(function () {
          if (text) text.textContent = 'Try again';
          reset(2000);
        });
    });
  }

  function label(root) {
    (root || document).querySelectorAll('.hs-card-add__chain:not([role])').forEach(function (el) {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Choose chain, currently ' + el.textContent.trim() + '.');
    });
  }
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.classList && e.target.classList.contains('hs-card-add__chain')) {
      e.preventDefault();
      e.target.click();
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { label(); });
  } else {
    label();
  }
  // Cards added later (load more, filters) get the same treatment.
  new MutationObserver(function () { label(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
